// schema
import * as ISchema from "@schema";
import {
  OnboardingStep,
  OnboardingMeta,
  OnboardingType,
  OnboardingTypeSource,
} from "./OnboardingNUX.d";
import { getBulkExperiments } from "@util/experiment.util";

// state
import { FastCrawlFlowStates } from "@state/onboarding";

export const defaultOnboarding = [
  OnboardingStep.Unstarted,
  OnboardingStep.Survey,
  OnboardingStep.IndividualJtbdSurvey,
  // OnboardingStep.TeamJtbdSurvey,
  OnboardingStep.TeamJoinCreate,
  OnboardingStep.WorkingHours,
  OnboardingStep.Lunch,
  OnboardingStep.Analyzing,
  OnboardingStep.IntroduceFocusTime,
  OnboardingStep.AutopilotIntroduction,
  OnboardingStep.AutopilotCarousel,
  OnboardingStep.Autopilot,
  OnboardingStep.ScheduleTestEvent,
  OnboardingStep.FocusTimeSync,
  OnboardingStep.Links,
  OnboardingStep.Invite,
  OnboardingStep.ColorCoding,
  OnboardingStep.PrivateCalendarSync,
  OnboardingStep.TravelTime,
  OnboardingStep.Slack,
  OnboardingStep.Summary,
  OnboardingStep.Finished,
];

export const linksOnboarding = [
  OnboardingStep.Unstarted,
  OnboardingStep.Survey,
  OnboardingStep.IndividualJtbdSurvey,
  // OnboardingStep.TeamJtbdSurvey,

  OnboardingStep.WorkingHours,
  OnboardingStep.Lunch,
  // OnboardingStep.Analyzing,
  OnboardingStep.FocusTimeSync,
  OnboardingStep.PrivateCalendarSync,
  OnboardingStep.Links,
  OnboardingStep.AutopilotIntroduction,
  OnboardingStep.AutopilotCarousel,
  OnboardingStep.Autopilot,
  OnboardingStep.Invite,
  OnboardingStep.ColorCoding,
  OnboardingStep.TravelTime,
  OnboardingStep.Slack,
  OnboardingStep.Summary,
  OnboardingStep.Finished,
];

export const managerOnboarding = [
  OnboardingStep.Unstarted,
  OnboardingStep.Survey,
  OnboardingStep.Analyzing,
  OnboardingStep.IntroduceFocusTime,
  OnboardingStep.TeamJoinCreate,
  OnboardingStep.WorkingHours,
  OnboardingStep.Lunch,
  OnboardingStep.FocusTimeSync,
  OnboardingStep.CarouselIntroduction,
  OnboardingStep.AutopilotCarousel,
  OnboardingStep.FlexMeeting,
  OnboardingStep.ScheduleTestEvent,
  OnboardingStep.Invite,
  OnboardingStep.SegmentedSummary,
  OnboardingStep.Links,
  OnboardingStep.PrivateCalendarSync,
  OnboardingStep.TravelTime,
  OnboardingStep.ColorCoding,
  OnboardingStep.Summary,
  OnboardingStep.Finished,
];

export const focusTimeSyncAndLunchHoldOnboarding = [
  OnboardingStep.Unstarted,
  OnboardingStep.Survey,
  OnboardingStep.IndividualJtbdSurvey,
  // OnboardingStep.TeamJtbdSurvey,
  OnboardingStep.TeamJoinCreate,
  OnboardingStep.WorkingHours,
  OnboardingStep.Analyzing,
  OnboardingStep.IntroduceFocusTime,
  OnboardingStep.FocusTimeSyncAndLunchHolds,
  OnboardingStep.AutopilotIntroduction,
  OnboardingStep.AutopilotCarousel,
  OnboardingStep.Autopilot,
  OnboardingStep.Links,
  OnboardingStep.Invite,
  OnboardingStep.ColorCoding,
  OnboardingStep.PrivateCalendarSync,
  OnboardingStep.TravelTime,
  OnboardingStep.Slack,
  OnboardingStep.Summary,
  OnboardingStep.Finished,
];

export const superchargedSteps = [
  OnboardingStep.ColorCoding,
  OnboardingStep.PrivateCalendarSync,
  OnboardingStep.TravelTime,
  OnboardingStep.Slack,
];

export const stepComponentLockMap = {
  [OnboardingStep.Unstarted]: false,
  [OnboardingStep.Survey]: false,
  [OnboardingStep.IndividualJtbdSurvey]: true,
  [OnboardingStep.TeamJtbdSurvey]: true,
  [OnboardingStep.TeamJoinCreate]: true,
  [OnboardingStep.WorkingHours]: true,
  [OnboardingStep.Lunch]: true,
  [OnboardingStep.FocusTimeSyncAndLunchHolds]: true,
  [OnboardingStep.Analyzing]: true,
  [OnboardingStep.IntroduceFocusTime]: true,
  [OnboardingStep.AutopilotIntroduction]: true,
  [OnboardingStep.CarouselIntroduction]: true,
  [OnboardingStep.AutopilotCarousel]: true,
  [OnboardingStep.Autopilot]: true,
  [OnboardingStep.FlexMeeting]: true,
  [OnboardingStep.ScheduleTestEvent]: false,
  [OnboardingStep.FocusTimeSync]: true,
  [OnboardingStep.Links]: false,
  [OnboardingStep.Invite]: true,
  [OnboardingStep.SegmentedSummary]: false,
  [OnboardingStep.ColorCoding]: true,
  [OnboardingStep.PrivateCalendarSync]: true,
  [OnboardingStep.TravelTime]: true,
  [OnboardingStep.Slack]: true,
  [OnboardingStep.Summary]: true,
  [OnboardingStep.Finished]: true,
};

export const skipableStepMap = {
  [OnboardingStep.Unstarted]: false,
  [OnboardingStep.Survey]: false,
  [OnboardingStep.IndividualJtbdSurvey]: true, // skip jtbd survey step by default
  [OnboardingStep.TeamJtbdSurvey]: false,
  [OnboardingStep.TeamJoinCreate]: false,
  [OnboardingStep.WorkingHours]: false,
  [OnboardingStep.Lunch]: false,
  [OnboardingStep.FocusTimeSyncAndLunchHolds]: false,
  [OnboardingStep.Analyzing]: false,
  [OnboardingStep.IntroduceFocusTime]: false,
  [OnboardingStep.AutopilotIntroduction]: false,
  [OnboardingStep.CarouselIntroduction]: false,
  [OnboardingStep.AutopilotCarousel]: false,
  [OnboardingStep.Autopilot]: false,
  [OnboardingStep.ScheduleTestEvent]: true, // skip test event step by default
  [OnboardingStep.FlexMeeting]: false,
  [OnboardingStep.FocusTimeSync]: false,
  [OnboardingStep.Links]: true, // skip onboarding links step by default
  [OnboardingStep.Invite]: false,
  [OnboardingStep.SegmentedSummary]: false,
  [OnboardingStep.ColorCoding]: false,
  [OnboardingStep.PrivateCalendarSync]: false,
  [OnboardingStep.TravelTime]: false,
  [OnboardingStep.Slack]: false,
  [OnboardingStep.Summary]: false,
  [OnboardingStep.Finished]: false,
};

export const requiresPostFastCrawlStepMap: Record<string, FastCrawlFlowStates> = {
  [OnboardingStep.TeamJoinCreate]: FastCrawlFlowStates.TeammatesIdentified,
  [OnboardingStep.IntroduceFocusTime]: FastCrawlFlowStates.UserCrawled,
  [OnboardingStep.AutopilotIntroduction]: FastCrawlFlowStates.UserCrawled,
  [OnboardingStep.Autopilot]: FastCrawlFlowStates.UserCrawled,
  [OnboardingStep.Invite]: FastCrawlFlowStates.TeammatesIdentified,
  [OnboardingStep.ColorCoding]: FastCrawlFlowStates.UserCrawled,
  [OnboardingStep.ScheduleTestEvent]: FastCrawlFlowStates.UserCrawled,
  [OnboardingStep.FlexMeeting]: FastCrawlFlowStates.UserCrawled,
};

export const navItems = [
  {
    initiallyHidden: false,
    supercharged: false,
    steps: [
      OnboardingStep.Survey,
      OnboardingStep.IndividualJtbdSurvey,
      OnboardingStep.TeamJoinCreate,
      OnboardingStep.WorkingHours,
      OnboardingStep.Lunch,
    ],
    label: "Tell us your needs",
  },
  {
    initiallyHidden: false,
    supercharged: false,
    steps: [
      OnboardingStep.IntroduceFocusTime,
      OnboardingStep.FocusTimeSyncAndLunchHolds,
      OnboardingStep.AutopilotIntroduction,
      OnboardingStep.AutopilotCarousel,
      OnboardingStep.Autopilot,
      OnboardingStep.ScheduleTestEvent,
      OnboardingStep.FlexMeeting,
      OnboardingStep.FocusTimeSync,
      OnboardingStep.Links,
      OnboardingStep.Invite,
      OnboardingStep.SegmentedSummary,
    ],
    label: "Make time together",
  },
  {
    initiallyHidden: false,
    supercharged: true,
    steps: [
      OnboardingStep.ColorCoding,
      OnboardingStep.PrivateCalendarSync,
      OnboardingStep.TravelTime,
      OnboardingStep.Slack,
    ],
    label: "Supercharge your calendar",
  },
  {
    initiallyHidden: true,
    supercharged: false,
    steps: [OnboardingStep.Summary],
    label: `You're all set! 🎉`,
  },
];

export const managerNavItems = [
  {
    initiallyHidden: false,
    supercharged: false,
    steps: [
      OnboardingStep.Survey,
      OnboardingStep.IntroduceFocusTime,
      OnboardingStep.TeamJoinCreate,
    ],
    label: "Get Started",
  },
  {
    initiallyHidden: false,
    supercharged: false,
    steps: [OnboardingStep.WorkingHours, OnboardingStep.Lunch, OnboardingStep.FocusTimeSync],
    label: "Tell us your needs",
  },
  {
    initiallyHidden: false,
    supercharged: false,
    steps: [
      OnboardingStep.CarouselIntroduction,
      OnboardingStep.AutopilotCarousel,
      OnboardingStep.Autopilot,
      OnboardingStep.ScheduleTestEvent,
      OnboardingStep.FlexMeeting,
      OnboardingStep.Invite,
      OnboardingStep.SegmentedSummary,
      OnboardingStep.Links,
      OnboardingStep.ColorCoding,
      OnboardingStep.PrivateCalendarSync,
      OnboardingStep.TravelTime,
      OnboardingStep.Slack,
    ],
    label: "Make time together",
  },
  {
    initiallyHidden: true,
    supercharged: false,
    steps: [OnboardingStep.Summary],
    label: `You're all set! 🎉`,
  },
];

export const getOnboardingType = (onboardingMeta: OnboardingMeta, org?: ISchema.IOrg) => {
  if (!!org && getBulkExperiments(org).ManagerSegmentedOnboarding) {
    const type = onboardingMeta.onboardingType;
    switch (type) {
      case OnboardingType.ManagerSegmentation:
        return OnboardingType.ManagerSegmentation;
      default:
        return OnboardingType.Default;
    }
  }
  if (!!org && getBulkExperiments(org).OnboardingFocusTimeSyncAndLunchStep) {
    return OnboardingType.FocusTimeSyncAndLunchHoldStep;
  }
  const type = onboardingMeta.onboardingType;
  switch (type) {
    case OnboardingType.Links:
      return OnboardingType.Links;
    default:
      return OnboardingType.Default;
  }
};

export const getOnboardingTypeSource = (onboardingMeta: OnboardingMeta) => {
  const typeSource = onboardingMeta.onboardingTypeSource;

  switch (typeSource) {
    case OnboardingTypeSource.LinksLandingPage:
      return OnboardingTypeSource.LinksLandingPage;
    case OnboardingTypeSource.WelcomeLoginPage:
      return OnboardingTypeSource.WelcomeLoginPage;
    default:
      return null;
  }
};

export const getOnboardingSteps = (onboardingType: OnboardingType) => {
  switch (onboardingType) {
    case OnboardingType.FocusTimeSyncAndLunchHoldStep:
      return focusTimeSyncAndLunchHoldOnboarding;
    case OnboardingType.Links:
      return linksOnboarding;
    case OnboardingType.ManagerSegmentation:
      return managerOnboarding;
    case OnboardingType.Default:
    default:
      return defaultOnboarding;
  }
};

export const getOnboardingCurrentStep = (onboardingState: ISchema.IFlowState) => {
  const currentState =
    onboardingState.current.state !== "MeetingHours"
      ? (onboardingState.current.state as OnboardingStep)
      : OnboardingStep.WorkingHours;

  if (!Object.values(OnboardingStep).includes(currentState)) {
    return OnboardingStep.Unstarted;
  }

  return currentState as OnboardingStep;
};
